import {orderDetail} from '@/api/server/order'
import commonMixin from '@/mixin/common'
import Tarbar from '@/components/Tabbar'
export default {
  name: 'OrderDetailPage',
  mixins: [commonMixin],
  data () {
    return {
        _id: null,
        orderInfo: null,
        orderGoods: null
    }
  },
  components: {
    Tarbar
  },
  methods: {
    _getDetail () {
        orderDetail(this._id).then((data) => {
            if (data.code === 200 && data.data) {
                this.orderInfo = data.data.orderInfo
                this.orderGoods = data.data.orderGoods
            } else {
                this.warning(data.message)
            }
        }).catch((e) => {
        console.log('err', e)
        })
    },
    reset () {
        this._getDetail()
    },
    handleRoute (route) {
      if (route.name === 'order-detail') {
        let id = this.$route.query.id
        if (!id) {
            this.warning('清正确提交')
        } else {
            this._id = id
        }
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
}